import { render, staticRenderFns } from "./growth-statistics-table.vue?vue&type=template&id=051f02be&scoped=true"
import script from "./growth-statistics-table.vue?vue&type=script&lang=js"
export * from "./growth-statistics-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051f02be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('051f02be')) {
      api.createRecord('051f02be', component.options)
    } else {
      api.reload('051f02be', component.options)
    }
    module.hot.accept("./growth-statistics-table.vue?vue&type=template&id=051f02be&scoped=true", function () {
      api.rerender('051f02be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/user/manage/components/growth-statistics-table.vue"
export default component.exports